import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-06ed84fe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "table-button-wrapper" }
const _hoisted_2 = { class: "table-button-left" }
const _hoisted_3 = { class: "table-button-right" }

import { InfoCircleOutlined } from '@ant-design/icons-vue'
import type { PropType } from 'vue'


const __default__ = { name: 'ButtonWrapperTips' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  text: {
    type: String as PropType<string>
  }
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_unref(InfoCircleOutlined)),
      _createElementVNode("span", null, _toDisplayString(__props.text), 1)
    ])
  ]))
}
}

})